import React from "react";
import DoctorList from "./DoctorList";
import "./Lab.css";
import { useSelector, useDispatch } from "react-redux";
import { selectUserId } from "../Login/loginSlice";
import { selectShowDoctorOrders, setShowDoctorOrders } from "./labSlice";
import { selectShowOrderCard, triggerBackToOrdersList } from "./Orders/orderSlice";

const Lab = () => {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const showDoctorOrders = useSelector(selectShowDoctorOrders);
    const showOrderCard = useSelector(selectShowOrderCard);

    const handleBack = () => {
        if (showOrderCard) {
            dispatch(triggerBackToOrdersList());
            return;
        }
        if (showDoctorOrders) {
            dispatch(setShowDoctorOrders(false));
        }
    };

    return (
        <div className="lab-container">
            <div className="lab-header">
                {showDoctorOrders ? (
                    <button
                        type="button"
                        className="lab-header-back"
                        onClick={handleBack}
                        aria-label={showOrderCard ? "Назад к заказам" : "Назад к врачам"}
                    >
                        ←
                    </button>
                ) : (
                    <span className="lab-header-spacer" />
                )}
                <span className="lab-header-title">
                    {showDoctorOrders ? 'Заказы' : 'Врачи'}
                </span>
                <span className="lab-header-spacer" />
            </div>
            <DoctorList userId={userId} />
        </div>
    );
};

export default Lab;
